import { Box, useTheme } from '@mui/joy';
import { KeyboardArrowUp } from '@mui/icons-material';
import { Link as ScrollLink } from 'react-scroll';
import { useMediaQuery } from '../../hooks/useMediaQuery';

/*this is used only on the Analysis page*/
const ScrollToTopButton = () => {
	const theme = useTheme();
	const scrollMatch = useMediaQuery(theme.breakpoints.up('smallLaptop'));
	const matchesMd = useMediaQuery(theme.breakpoints.up('md'));

	return (
		<Box sx={{ display: matchesMd ? 'block' : 'none', marginTop: '5rem' }}>
			<ScrollLink
				style={{
					cursor: 'pointer'
				}}
				to={'topOfPage'}
				smooth='easeInOutCubic'
				offset={scrollMatch ? -156 : 0}
				duration={500}
			>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						borderRadius: '50%',
						width: '2.5rem',
						height: '2.5rem',
						flex: 1,
						backgroundColor: theme.palette.chaptersAnalysis.solidBg3,
						margin: '-2rem auto 0',
						':hover': {
							backgroundColor: theme.palette.controls.controlFill,
							'& .MuiSvgIcon-root': {
								color: '#FFFFFF'
							}
						}
					}}
				>
					<KeyboardArrowUp
						sx={{ fontSize: '2rem', color: theme.typography.body1.color }}
					/>
				</Box>
			</ScrollLink>
		</Box>
	);
};
export default ScrollToTopButton;
